import { Box, BoxProps, lighten } from '@mui/material';
import { ReactNode } from 'react';

export type MutedContentProps = {
  children: ReactNode;
} & Omit<BoxProps, 'children'>;

export const MutedContent = ({ children, sx, ...rest }: MutedContentProps) => (
  <Box
    component='span'
    sx={{
      color: (theme) => lighten(theme.palette.text.disabled, 0.475),
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);
